import Vue from 'vue';

export default {
  state: {
    refinancingStatuses: [],
  },
  getters: {
    // eslint-disable-next-line
    refinancingStatus: state => (id) => {
      return state.refinancingStatuses.find(item => item.id === id) || {};
    },
  },
  mutations: {
    SET_REFINANCING_STATUSES(state, payload) {
      state.refinancingStatuses = payload;
    },
  },
  actions: {
    GET_REFINANCING_STATUSES(context) {
      return Vue.axios.get('refinancing/sub_statuses').then((response) => {
        context.commit('SET_REFINANCING_STATUSES', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/refinancing.js